import { Getters } from "vuex";
import { ActionCableGetters, ActionCableState } from "./types";

export const getters: Getters<ActionCableState, ActionCableGetters> = {};
